import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './Componentes/Autenticacion/login/login.component';
import { RecuperarComponent } from './Componentes/Autenticacion/recuperarcontrasena/recuperar.component';
import { CambioComponent } from './Componentes/Autenticacion/cambiocontrasena/cambio.component';
import { HomeComponent } from './Componentes/Inicio/Home/home.component';
import { AdminGuard } from './AdminGuard';
import { LogoComponent } from './Componentes/Inicio/logo/logo.component';
import { MantenedorSucursalListComponent } from './Componentes/mantenedores/mantenedor-sucursal/mantenedor-sucursal-list/mantenedor-sucursal-list.component';
import { MantenedorUsuarioListComponent } from './Componentes/mantenedores/mantenedor-usuario/mantenedor-usuario-list/mantenedor-usuario-list.component';
import { RepoteComisionesComponentComponent } from './Componentes/Reportes/repote-comisiones-component/repote-comisiones-component.component';
import { RepoteVentasComponentComponent } from './Componentes/Reportes/repote-ventas-component/repote-ventas-component.component';
import { VentasListComponent } from './Componentes/ventas/ventas-list/ventas-list.component';
import { ReporteVentasVendedorComponent } from './Componentes/Reportes/reporte-ventas-vendedor/reporte-ventas-vendedor.component';


const routes: Routes = [
  {path: '', redirectTo: 'login', pathMatch: 'full'},
  {path: 'login', component: LoginComponent,  canActivate: [AdminGuard] },
  {path: 'recuperar', component: RecuperarComponent,   canActivate: [AdminGuard] },  
  {path: 'home', component: HomeComponent,   canActivate: [AdminGuard] ,   
    children:[
      {path: 'cambio', component: CambioComponent},      
      {path: 'Menu_Logo', component: LogoComponent},      
      {path: 'menu_Mantenedor_Sucursal', component: MantenedorSucursalListComponent},
      {path: 'menu_Mantenedor_Usuario', component: MantenedorUsuarioListComponent},      
      {path: 'reporte_ventas', component: RepoteVentasComponentComponent},      
      {path: 'reporte_comisiones', component: RepoteComisionesComponentComponent},
      {path: 'menu_Mantenedor_Usuario', component: MantenedorUsuarioListComponent},
      {path: 'menu_Ventas_Listar', component: VentasListComponent},
      {path: 'reporte_ventas_vendedor', component: ReporteVentasVendedorComponent}
  ]},
  {path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
